/*
  CVSS base score -> qualitative severity rating.
  Bands are the ones defined by the CVSS v3.1 and v4.0 specifications, so the
  label always agrees with the rating published on the advisory itself.
*/

export const SEVERITIES = ["Critical", "High", "Medium", "Low"];

export const severityOf = (cvss) => {
  const score = Number(cvss);

  if (!Number.isFinite(score) || score <= 0) return "";
  if (score >= 9.0) return "Critical";
  if (score >= 7.0) return "High";
  if (score >= 4.0) return "Medium";

  return "Low";
};

export default severityOf;
